export default {
    antMiniInfo: {
        method: 'get',
        url: '/system_settings/ant_mini_program_info'
    },
    editAntMiniInfo: {
        method: 'post',
        url: '/system_settings/ant_mini_program_info'
    },
    tradeSplit: {
        method: 'get',
        url: '/system_settings/trade_split_settings'
    },
    editTradeSplit: {
        method: 'post',
        url: '/system_settings/trade_split_settings'
    }
};



// WEBPACK FOOTER //
// ./src/api/system-settings.js